import { render } from "./ViewerDeviceActions.vue?vue&type=template&id=289fd51d&ts=true"
import script from "./ViewerDeviceActions.vue?vue&type=script&lang=ts"
export * from "./ViewerDeviceActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardActions,QBtn});
